import React from 'react';
import { NotificationBody, NotificationBodyProps } from './NotificationBody';
import { NotificationTitle } from './NotificationTitle';

export type SettingsItemProps = {
  title: string;
  channels: NotificationBodyProps;
};

export const SettingsItem = ({ title, channels }: SettingsItemProps) => {
  return (
    <>
      <NotificationTitle title={title} />
      <NotificationBody {...channels} />
    </>
  );
};
